import React from 'react';

import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { useNode } from '@craftjs/core';

import { Box } from '@mui/material';

import NumberInput from '@common/components/NumberInput/NumberInput';
import SettingsRow from '@common/components/SettingsWrapper/SettingsRow';

const MarginStyle = ({ min = 0, max = 500, hide = {}, sx = {} }) => {
  const { t } = useTranslation();
  const {
    actions: { setProp },
    marginLeft,
    marginRight,
    marginTop,
    marginBottom,
  } = useNode(({ data: { props } }) => {
    return {
      marginLeft: props.marginLeft,
      marginRight: props.marginRight,
      marginTop: props.marginTop,
      marginBottom: props.marginBottom,
    };
  });

  const onChange = (e) => {
    setProp((props) => {
      props[e.target.name] = e.target.value;
    }, 500);
  };

  return (
    <Box autoComplete='off' sx={sx}>
      {!hide?.horizontal && (
        <SettingsRow sx={{ mb: 2 }}>
          <NumberInput
            min={min}
            max={max}
            label={t('margin_left')}
            value={marginLeft}
            name='marginLeft'
            onChange={onChange}
          />
          <NumberInput
            min={min}
            max={max}
            label={t('margin_right')}
            value={marginRight}
            name='marginRight'
            onChange={onChange}
          />
        </SettingsRow>
      )}
      {!hide?.vertical && (
        <SettingsRow>
          <NumberInput
            min={min}
            max={max}
            label={t('margin_top')}
            value={marginTop}
            name='marginTop'
            onChange={onChange}
          />
          <NumberInput
            min={min}
            max={max}
            label={t('margin_bottom')}
            value={marginBottom}
            name='marginBottom'
            onChange={onChange}
          />
        </SettingsRow>
      )}
    </Box>
  );
};

MarginStyle.propTypes = {
  onChange: PropTypes.func,
  marginLeft: PropTypes.string,
  marginRight: PropTypes.string,
  marginTop: PropTypes.string,
  marginBottom: PropTypes.string,
};

export default MarginStyle;
